import React from 'react';
import './PaymentCard.scss';

const PaymentCard = ({ children, className = '' }) => {
  return (
    <div className={`payment-card ${className}`}>
      <div className="payment-card__content">
        {children}
      </div>
    </div>
  );
};

export default PaymentCard;
